<template lang="html">

    <div class="main-form">
        <div class="main-form__logo">
            <img src="@/assets/images/logo.svg" alt="Nexyo Logo">
        </div>
        <div class="main-form__container">
            <div class="main-form__title">
                Resetare parolă
            </div>
            <div v-if="isLoading === false && success === false" class="main-form__text" style="text-align: center;">
                <span v-for="error in apiErrors" :key="error" class="error">{{error}}<br></span>
            </div>
            
            <div v-else-if="isLoading && secretChecking" style="margin-top: 10px; text-align: center">
                Se incarcă...
            </div>
            <div v-else-if="success === false && secretChecking" style="margin-top: 10px; text-align: center">
                <p v-for="error in apiErrors" :key="error" class="error">
                    {{ error }}
                </p>
            </div>

            <template v-else>
                <UiInput label="Noua parolă"
                    type="password"
                    placeholder="Parolă.."
                    :value="password"
                    :error="errors.password"
                    :disabled="isLoading"
                    @input="password = $event, validatePassword()"
                    @blur="validatePassword"
                    @keyup="sendOnEnter"
                />

                <div class="main-form__submit">
                    <UiButton 
                        shape="square"
                        :name="isLoading ? 'Se incarcă...' : 'Continuă'"
                        @click="resetMyPassword"
                        :disabled="disabledButton"
                    />
                </div>
            </template>

            <router-link to="/login" tag="span">
                <div class="main-form__subtext">
                    Înapoi la <a>pagina de autentificare</a>.
                </div>
            </router-link>
        </div>
    </div>
    <!-- <div class="main-form">
        <div class="main-form__title">
            Resetare parolă
        </div>
        <div v-if="isLoading === false && success === false" class="main-form__text" style="text-align: center;">
            <span v-for="error in apiErrors" :key="error" class="error">{{error}}<br></span>
        </div>
        
        <div v-else-if="isLoading && secretChecking" style="margin-top: 10px; text-align: center">
            Se incarcă...
        </div>
        <div v-else-if="success === false && secretChecking" style="margin-top: 10px; text-align: center">
            <p v-for="error in apiErrors" :key="error" class="error">
                {{ error }}
            </p>
        </div>
        
        <template v-else>
            <div class="field">
                <UiInput label="Parolă"
                    type="password"
                    placeholder="Parolă.."
                    :value="password"
                    :error="errors.password"
                    :disabled="isLoading"
                    @input="password = $event, validatePassword()"
                    @blur="validatePassword"
                    @keyup="sendOnEnter"
                />
            </div>

            <div class="main-form__text">
                <span>Vei primi un email cu pașii necesari pentru resetarea parolei.</span>
            </div>

            <div class="main-form__submit">
                <UiButton 
                    shape="square"
                    :name="isLoading ? 'Se incarcă...' : 'Continuă'"
                    @click="resetMyPassword"
                    :disabled="disabledButton"
                />
            </div>
        </template>

        <router-link to="/login" tag="span">
            <div class="main-form__subtext">
                Înapoi la <a>pagina de autentificare</a>.
            </div>
        </router-link>
    </div> -->
</template>

<script>

import UiInput from '@/components/ui/Input.vue'
import UiButton from '@/components/ui/Button'

import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

export default {
    components: {
        UiInput,
        UiButton
    },
    data() {
        return {
            password: '',
            passwordConfirmation: '',
            errors: {
                password: '',
                passwordConfirmation: ''
            },
            apiErrors: null,
            success: false,
            isLoading: true,
            secretChecking: true,
        }
    },
    mounted() {
        this.checkResetPassword({ secret: this.$route.params.secret });
    },
    methods: {
        ...mapActions({
            resetPassword: 'user/resetPassword',
            checkResetPassword: 'user/checkResetPassword',
        }),
        resetMyPassword() {
            if(this.disabledButton === false && this.isLoading === false) {
                this.isLoading = true;

                var data = {
                    secret: this.$route.params.secret,
                    password: this.password,
                    password_confirmation: this.password,
                }

                this.resetPassword(data);
                this.errors.email = '';
                this.errors.apiErrors = null;
            }
        },
        sendOnEnter(event) {
            if (event.keyCode === 13) {
                this.resetMyPassword();
            }
        },
        validatePassword() {
            this.apiErrors = null;
            if(this.password.length > 0 && this.password.length < 6)
                this.errors.password = 'Parola trebuie să contină minim 6 caractere';
            else {
                this.errors.password = '';
            }
        },
        validatePasswordConfirmation() {
            this.apiErrors = null;
            if(this.passwordConfirmation.length > 0 && this.passwordConfirmation.length < 6)
                this.errors.passwordConfirmation = 'Confirmarea parolei trebuie sa contină minim 6 caractere';
            else if(this.passwordConfirmation.localeCompare(this.password))
                this.errors.passwordConfirmation = 'Parolele nu se potrivesc';
            else {
                this.errors.password = '';
                this.errors.passwordConfirmation = '';
            }
        },
    },
    computed: {
        disabledButton() {
            if (this.isLoading) return true;

            if (
                this.errors.password === ''
                //&& this.errors.passwordConfirmation === ''
                && (
                    this.password.length > 0
                    //&& this.passwordConfirmation.length > 0
                )
            ) {
                return false;
            }

            return true;
        }
    },
    watch: {
        "$store._modules.root.state.notification.notification.icon"(icon) {
            this.success = (icon === 'success');

            if (this.success) {
                this.secretChecking = false;
            }
		},
        "$store._modules.root.state.notification.notification.title"(notification) {
            this.isLoading = false;
            this.apiErrors = notification;
		}
    }
}
</script>